import { useEffect } from 'react'
import { useRouter } from 'next/router'
import * as gtm from '@/libs/google/gtm'

interface Props {
  children: JSX.Element
}
export const GoogleTagManager: React.FC<Props> = ({ children }) => {
  const router = useRouter()

  useEffect(() => {
    gtm.optimize()
  }, [router])
  return children
}
